export default function MySQL_HAVING() {
  return (
    <div>
      <h2>MySQL_HAVING</h2>    </div>
  );
}